import { render } from "./PageContentHeader.vue?vue&type=template&id=6a67a4a8"
import script from "./PageContentHeader.vue?vue&type=script&lang=js"
export * from "./PageContentHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__